module.exports = __webpack_public_path__ + "img/001.1b1b73e3.svg";